// Modules
import { createSelector } from '@ngrx/store';

// Store - Reducers
import { AppState } from '@store/reducers';
import * as DashboardAutoStatisticsReducer from '@store/reducers/dashboard.reducer';

export const selectDashboardAutoStatisticsState = (state: AppState) =>
  state.dashboardAutoStatistics;

export const selectDashboardAutoStatistics = createSelector(
  selectDashboardAutoStatisticsState,
  (state: DashboardAutoStatisticsReducer.DashboardAutoStatisticsState) =>
    state.dashboardAutoStatistics
);

export const selectLoadingStatus = createSelector(
  selectDashboardAutoStatisticsState,
  (state: DashboardAutoStatisticsReducer.DashboardAutoStatisticsState) =>
    state.loading
);
